export default "__VITE_ASSET__CyJsWmKu__"